<div
  class="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-950 transition-colors duration-300"
>
  <app-banner></app-banner>

  <main class="grow flex flex-col">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
  <app-toast></app-toast>
  <app-cookie-consent></app-cookie-consent>
</div>
